<template>
    <div class="permissionList">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>权限管理</el-breadcrumb-item>
            <el-breadcrumb-item>查询权限</el-breadcrumb-item>
        </el-breadcrumb>
        <el-table class="permission-list-table" :data="permissionList" stripe border>
            <el-table-column label="权限ID" align='center'>
                <template scope="scope">
                    <span>{{scope.row.permissionsId}}</span>
                </template>
            </el-table-column>
            <el-table-column label="权限名称" align='center'>
                <template scope="scope">
                    <span>{{scope.row.permissionsName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align='center'>
                <template scope="scope">
                    <!--<el-button size="small" type="info" @click="">编辑</el-button>-->
                    <el-button size="small" type="danger" @click="deletePermission(scope.row.permissionsId)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页器-->
        <el-pagination class="page-control" layout="prev, pager, next" :total="permissionListLength"></el-pagination>
        <!--end-->
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
export default {
    name: "permissionList",
    data(){
        return {
            permissionList: null,
            permissionListLength: 0
        };
    },
    mounted(){
        this._init();
    },
    methods: {
        _confirmMessage(message, success = ()=>{}, cancel = ()=>{}) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(success).catch(cancel);          
        },
        _getPermissions() {
            this.$http.get(CONFIG.HOST + '/users/listPermissions' + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.permissionList = result.data;
                    this.permissionListLength = this.permissionList.length || 0;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            },(response)=>{
                console.log(response);
            });
        },
        deletePermission(permissionsId){
            this._confirmMessage('是否确定删除permissionId=' + permissionsId + '的权限？', ()=>{
                if (permissionsId < 0) {
                    this.$notify.error({
                        message: '【营销平台】permissionId=' + permissionsId + '的权限不存在'
                    });
                    return;
                }
                this.$http.delete(CONFIG.HOST + '/users/deletePermissions/' + permissionsId).then((response)=>{
                    let result = response.body;
                    if (result && result.status === 1) {
                        this._getPermissions();
                    } else {
                        this.$notify.error({
                            message: result.message
                        });
                    }
                },(response)=>{
                    console.log(response);
                });
            });
        },
        _init(){
            this._getPermissions();
        }
    }
};
</script>
<style lang="less">
     .permissionList{
         width: 98%;
         margin: 0 auto;
         .bread-nav{
             margin: 20px 0;
         }
         .permission-list-table{
             min-width: 980px;
         }
         .page-control{
             margin: 20px auto 0 auto;
         }
     }
</style>


// WEBPACK FOOTER //
// List.vue?531fd042